export const responseHandler = async(response) => {

    // 200 to 299 successful response
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
 
    // 400 to 499 client side error
    if(response.status === 400){
        response.extra_message = "Bed Request.";
        return response;
    }
    if(response.status === 401 || response.status === 403){
        window.location.href = "/home";
    }
    if(response.status === 404){
        response.extra_message = "Not found";
        return response;
    }
    if(response.status === 408){
        response.extra_message = "Request Timeout";
        return response;
    }
    if(response.status === 422){
        response.extra_message = "Unprocessable Content";
        return response;
    }
    if(response.status === 429){
        response.extra_message = "Too Many Requests";
        return response;
    }
 
 
    // 500 to 599 server side error
    if(response.status === 500){
        response.extra_message = "Internal Server Error";
        return response;
    }
    if(response.status === 501){
        response.extra_message = "Not Implemented";
        return response;
    }
    if(response.status === 502){
        response.extra_message = "Bad Gateway";
        return response;
    }
    if(response.status === 503){
        response.extra_message = "Service Unavailable";
        return response;
    }
    if(response.status === 504){
        response.extra_message = "Gateway Timeout";
        return response;
    }
    if(response.status === 505){
        response.extra_message = "HTTP Version Not Supported";
        return response;
    }
}